// Pinch and double-tap zoom the page itself in Safari when they start on the
// card or the panel, not the map, and the page stays zoomed after the card
// closes. The map handles its own pinches; everything else refuses them.

const onMap = (target: EventTarget | null): boolean => target instanceof Element && target.closest('#map') !== null;

export function guardTouch(): void {
  document.addEventListener(
    'touchmove',
    (e) => {
      if (e.touches.length > 1 && !onMap(e.target)) e.preventDefault();
    },
    { passive: false },
  );
  // Safari's pinch events, which fire on the page whatever touch-action says.
  for (const type of ['gesturestart', 'gesturechange']) {
    document.addEventListener(
      type,
      (e) => {
        if (!onMap(e.target)) e.preventDefault();
      },
      { passive: false },
    );
  }
  // A double tap on the card or panel would zoom the page.
  let lastTap = 0;
  document.addEventListener(
    'touchend',
    (e) => {
      if (onMap(e.target)) return;
      const t = Date.now();
      if (t - lastTap < 350 && !(e.target instanceof HTMLElement && e.target.closest('button, a, input, textarea'))) {
        e.preventDefault();
      }
      lastTap = t;
    },
    { passive: false },
  );
}
